<template>
  <div class="callbackcss">
    <el-row type="flex"
            style="height: 100%;"
            align="middle"
            justify="center">
      <div style="height: 500px;box-shadow:0 0 15px rgba(236,249,247,0.2);overflow: hidden;">
        <div style="display:inline-block;height: 100%;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_left.png" />
        </div>
        <div style="display:inline-block;height: 100%;position: relative;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_right.png" />
          <div style="position: absolute;top:0;left:0;width:100%;height: 100%;"
               v-loading="loading">
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Callback',
  data () {
    return {
      loading: false,
      openId: '',
      userphone: '',
      cancellation: '',
      unBind: '',
    }
  },
  created () {
    let param = this.$route.query || {};
    let code = param.code;
    this.cancellation = param.cancellation;
    this.unBind = param.unbind;
    let uid = param.uid;
    if (code && uid) {
      //用户绑定微信
      this.bindUserWx(code, param.uid);
      return;
    }
    if (code) {
      //微信登录重定向
      this.getUserInfoByWxCode(param.code);
      return;
    }
    //其它方式访问，跳转微信登录页面
    this.$router.replace('/wxlogin');
  },
  methods: {
    showCancellation () {
      this.$confirm('确定要注销账号：' + this.userphone + ' 吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.submitCancellation();
      }).catch(() => {
        //取消注销，跳转微信登录页面
        this.$router.replace('/wxlogin');
      });
    },
    showUnBind () {
      this.$confirm('账号：' + this.userphone + ' 确定要解绑微信吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.submitUnbind();
      }).catch(() => {
        //取消解绑，跳转微信登录页面
        this.$router.replace('/wxlogin');
      });
    },
    openLink (url) {
      window.open(url);
    },
    submitUnbind () {
      //解绑微信
      this.loading = true;
      this.$request.post('api/Platform/IntegrationUserAuth/UnBindUser/', { openid: this.openId }).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          if (response.data.state) {
            //微信解绑成功
            this.$alert('您的微信已解绑！', '提示', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: action => {
                this.$router.replace('/wxlogin');
              }
            });
          } else {
            //解绑失败
            this.$alert(response.message, '微信解绑失败', {
              confirmButtonText: '返回',
              type: 'error',
              callback: action => {
                this.$router.replace('/wxlogin');
              }
            });
          }
        } else {
          this.$router.replace('/wxlogin');
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
          this.$router.replace('/wxlogin');
        });
    },
    submitCancellation () {
      //用户注销
      this.loading = true;
      this.$request.post('api/Platform/IntegrationUserAuth/UnLogOffByOpenId/', { openid: this.openId }).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          if (response.data.state) {
            //注销成功
            this.$alert('您的账号已注销！', '提示', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: action => {
                this.$router.replace('/wxlogin');
              }
            });
          } else {
            //注销失败
            this.$alert(response.message, '账号注销失败', {
              confirmButtonText: '返回',
              type: 'error',
              callback: action => {
                this.$router.replace('/wxlogin');
              }
            });
          }
        } else {
          this.$router.replace('/wxlogin');
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
          this.$router.replace('/wxlogin');
        });
    },
    bindUserWx (code, uid) {
      //用户绑定微信
      this.loading = true;
      this.$request.get('api/Platform/IntegrationUserAuth/updateUserByAppId/', { params: { code: code, userid: uid } }).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          if (response.data.state) {
            //微信绑定成功
            this.$alert('您的账号已成功绑定微信，可以使用微信扫码便捷登录了！', '微信绑定成功', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: action => {
                this.openBIUrl(response.data.links);
              }
            });
          } else {
            //绑定失败,可能已绑定其它账号
            this.$alert(response.message, '微信绑定失败', {
              confirmButtonText: '知道了',
              type: 'error',
              callback: action => {
                this.openBIUrl(response.data.links);
              }
            });
          }
        } else {
          this.$message.error(response.message);
          this.$router.replace('/wxlogin');
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请刷新页面重试！");
        });
    },
    getUserInfoByWxCode (code) {
      //通过微信code获取用户信息
      this.loading = true;
      this.$request.get('api/Platform/IntegrationUserAuth/getUserByAppId/', { params: { code: code } }).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          if (this.cancellation) {
            if (response.data.state) {
              //用户存在，注销账号
              this.openId = response.data.user.openid;
              this.userphone = response.data.user.phone;
              this.showCancellation();
              return;
            } else {
              //用户不存在
              this.$alert('用户不存在！', '提示', {
                confirmButtonText: '知道了',
                type: 'success',
                callback: action => {
                  this.$router.replace('/wxlogin');
                }
              });
              return;
            }
          }
          if (this.unBind) {
            if (response.data.state) {
              //用户存在，注销账号
              this.openId = response.data.user.openid;
              this.userphone = response.data.user.phone;
              //解绑微信
              this.showUnBind();
              return;
            } else {
              //用户不存在
              this.$alert('用户不存在！', '提示', {
                confirmButtonText: '知道了',
                type: 'success',
                callback: action => {
                  this.$router.replace('/wxlogin');
                }
              });
              return;
            }
          }
          this.filterResponse(response.data);
        } else {
          this.$message.error(response.message);
          this.$router.replace('/wxlogin');
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请刷新页面重试！");
        });
    },
    filterResponse (res) {
      if (res.state) {
        //用户存在
        this.openBIUrl(res.links);
      } else {
        //用户不存在，录入用户信息
        this.$router.push('/register?wxid=' + res.openid);
      }
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url;
      } else {
        alert('没有可使用的系统!');
      }
    }
  }
}
</script>

<style lang="scss">
.callbackcss {
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 550px;
  background-image: url(../../public/img/loginbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>